import { render, staticRenderFns } from "./NavbarMenuItem.vue?vue&type=template&id=15f4c43a&"
import script from "./NavbarMenuItem.vue?vue&type=script&lang=js&"
export * from "./NavbarMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports